/* eslint-disable flowtype/no-types-missing-file-annotation */
/* eslint-disable max-classes-per-file */
// @flow
import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Provider, connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Routes from './routes';
import { Root } from './components';
import ReCaptchaProvider from './components/ReCaptchaProvider';
import { userProfileRequest } from 'redux/User/actions';

declare type Props = {
  store: StoreType,
};

const mapDispatchToProps = (dispatch) => ({
  userProfile: () => dispatch(userProfileRequest()),
});
function mapStateToProps(): StatePropsType {
  return {};
}
declare type DispatchPropsType = {
  userProfile: Function,
};

const RootComponentWithRoutes = (props) => {
  return (
    <Root {...props}>
      <Routes />
    </Root>
  );
};

class App extends React.Component<Props & DispatchPropsType & StatePropsType> {
  componentDidMount() {
    const { userProfile } = this.props;
    userProfile();
  }
  componentDidUpdate(prevProps) {
    const { userProfile } = this.props;
    if (prevProps.userProfile !== userProfile) {
      userProfile();
    }
  }
  render() {
    const { store } = this.props;
    return (
      <Provider store={store}>
        <ReCaptchaProvider>
          <Router basename="/">
            <Route path="/" component={(props) => RootComponentWithRoutes(props)} />
          </Router>
        </ReCaptchaProvider>
      </Provider>
    );
  }
}

function helper(Component) {
  return class Wrapper extends React.Component<StatePropsType & DispatchPropsType & Props> {
    render() {
      return (
        <>
          <Component {...this.props} />
          <ToastContainer />
        </>
      );
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(helper(App));
